// API Configuration Constants
// Always use current domain for API calls
export const API_HOST = typeof window !== 'undefined' ? window.location.origin : '';
export const API_PATH = '/api';
export const API_PREFIX_PATH = API_PATH;

// Backend URL - for making API calls
export const BACKEND_URL = typeof window !== 'undefined' 
  ? `${window.location.origin}/api` 
  : '/api';
